import Modal from '@/components/Modal'
import { Avatar, Flex, getTheme, Text } from '@conexasaude/conexa-hero'
import { Icon } from '@conexasaude/iconography/icons'
import { FunctionComponent } from 'react'
import { useConfirmConsultationModal } from './ConfirmConsultationModal.hook'
import { ConfirmConsultationModalProps } from './ConfirmConsultationModal.types'

export const ConfirmConsultationModal: FunctionComponent<
  ConfirmConsultationModalProps
> = props => {
  const theme = getTheme()
  const { actions, loadings, formattedDate } =
    useConfirmConsultationModal(props)

  return (
    <Modal
      id="CONFIRM_CONSULTATION"
      title="Confirme sua consulta"
      primaryActionLabel="Confirmar"
      negativeActionLabel="Fechar"
      negativeAction={actions.closeModal}
      primaryAction={actions.handlePrimaryAction}
      busyPrimaryAction={loadings.primaryActionIsLoading}
      size={550}
    >
      <Flex
        mt={theme.spacing.sm}
        mb={{ sm: theme.spacing.sm }}
        direction="column"
      >
        <Flex direction="column" gap={theme.spacing.xs}>
          <Avatar size={50} src={props?.professional?.photo} />

          <Text
            variant="headingMedium"
            renderAs="span"
            color={theme.colors.neutral[500]}
          >
            Você tem uma consulta com{' '}
            <Text
              variant="headingLarge"
              color={theme.colors.brand.primary[300]}
            >
              {props?.professional?.name}
            </Text>
          </Text>
        </Flex>

        <Flex
          mt={theme.spacing.xs}
          mb={theme.spacing.sm}
          gap={theme.spacing.sm}
          direction={{ base: 'column', sm: 'row' }}
        >
          <Flex gap={theme.spacing.xxs}>
            <Icon name="calendar" color={theme.colors.neutral[200]} />
            <Text variant="paragraphSmall">{formattedDate.date}</Text>
          </Flex>
          <Flex gap={theme.spacing.xxs}>
            <Icon name="clock" color={theme.colors.neutral[200]} />
            <Text variant="paragraphSmall">
              {formattedDate.hour} (horário de Brasília)
            </Text>
          </Flex>
        </Flex>

        <Text variant="headingSmall" color={theme.colors.neutral[400]}>
          Podemos confirmar sua consulta?
        </Text>
      </Flex>
    </Modal>
  )
}
